<div class="aside_title-section">
  <h1 class="title-dashboard">{{ 'ANOMALY.DIAGNOSTIC' | translate }}</h1>
</div>
@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'device' })) {
  <div class="widget-content-height">
    @if ($devices()?.length) {
      @for (device of $devices() | slice: 0 : 5; track device) {
        <device-card [display]="'error'" [d]="device.uid" [isDisplayDriver]="false" />
      }
    } @else {
      <div class="missing-data-dashboard">
        <p>{{ 'ANOMALY.NO_DIAGNOSTIC' | translate }}</p>
      </div>
    }
  </div>
  @if ($devices()?.length > 5) {
    <div class="data-more-icon">
      <mat-icon [routerLink]="[DEVICES_DIAGNOSTIC]" [matTooltip]="'COMMON.SEEMORE' | translate">
        more_horiz
      </mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
